import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';

import { useGetBuhHandlingOptions } from '../hooks/useGetBuhHandlingOptions';

export const BuhHandlingSelect = () => {
  const { t } = useTranslation('common', { keyPrefix: 'employerCostSettings' });
  const { control } = useFormContext();

  const options = useGetBuhHandlingOptions();

  return (
    <ControlledSelect
      control={control}
      label={t('grid.buhHandlingSvc')}
      name="buhHandlingSvc"
      options={options}
      variant="outlined"
    />
  );
};
